import $ from 'jquery';
import BaseClass from '../base/BaseClass';
import Util from '../util/Util';

/**
 * 画像ロード監視クラス
 * @param {String} _target 対象となるクラス名やid名 デフォルトbody
 *
 * @example
 * const self = this;
 * const imageLoad = new ImageLoadClass($("#main"));
 * imageLoad.bind(imageLoad.ONLOADEND,function(){
 *      self.onAllImageLoadComplete();
 * });
 * imageLoad.onLoad();
 */
export default class ImageLoadClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'ImageLoadClass';
    this.target = (_target) ? _target : 'body';
    this.par = 0;
    this.loadCount = 0;
    this.arr = [];
    this.objArr = [];
    this.count = 0;
    this.isRemove = false;
    this.ONPROGRESS = 'onProgress';
    this.ONLOADEND = 'onLoadEnd';
  }

  onLoad() {
    this.count = 0;
    let self = this;

    let tImg = $(this.target).attr('src');
    if (tImg != null) { self.arr.push(tImg); }
    let tBg = $(this.target).css('background-image').match(/https?:\/{2}[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+[a-z]/g);
    if (tBg != null) { self.arr.push(tBg[0]); }

    $('img', this.target).each((index, element) => {
      let s = $(element).attr('src');
      if (s != null) { self.arr.push(s); }
    });

    $('*', this.target).each((index, element) => {
      let b = $(element).css('background-image').match(/https?:\/{2}[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+[a-z]/g);
      if (b != null) { self.arr.push(b[0]); }
    });

    this.arr = Util.getUniqueArr(this.arr);

    for (let i = 0; i < this.arr.length; i++) {
      let imgObj = new Image();
      imgObj.src = this.arr[i];
      imgObj.onload = () => {
        if (self.isRemove) { return; }
        self.count++;
        self.jq.trigger(self.ONPROGRESS, { par: self.count / self.objArr.length });
      };
      imgObj.onerror = () => {
        if (self.isRemove) { return; }
        self.count++;
        self.jq.trigger(self.ONPROGRESS, { par: self.count / self.objArr.length });
      };
      this.objArr.push(imgObj);
    }

    let tId;
    let checkFunc = () => {
      if (self.isRemove) {
        clearTimeout(tId);
        return;
      }
      if (self.count === self.objArr.length) {
        clearTimeout(tId);
        self.jq.trigger(self.ONLOADEND);
      }
    };
    tId = setInterval(checkFunc, 100);
  }

  onRemove() {
    this.isRemove = true;
    for (let o in this.objArr) { this.objArr[o] = null; }
    this.objArr = null;
    for (let a in this.arr) { this.arr[a] = null; }
    this.arr = null;
  }

  addImg(a) {
    this.arr = this.concat(a);
  }
}
